import axios from "../axios";

export interface IReportSummary {
  currentWeekLeads: number;
  previousWeekLeads: number;
  leadChangePercent: number;
  totalLeads: number;
  activeProviders: number;
  subscriptionPercent: number;
  microPercent: number;
  matchedLeads?: number;
  needsAttentionLeads?: number;
  matchRatePercent?: number;
}

export interface IReportWeeklyData {
  weekLabel: string;
  startDate: string;
  leads: number;
  cumulativeLeads: number;
  activityLeadsCreated: number;
  activityLeadsUpdated: number;
  activityLogins: number;
  activityLeadsOpened: number;
  activityOffersSaved: number;
  activityProfileUpdates: number;
  totalActivity: number;
  subscriptionProviders: number;
  microProviders: number;
}

export interface IReportAttribution {
  DIRECT: number;
  AI: number;
  PARTNERS: number;
  SEARCH: number;
  OTHER: number;
}

export interface IReportResponse {
  summary: IReportSummary;
  timeSeries: IReportWeeklyData[];
  attribution: IReportAttribution;
}

export const getReportData = async (serviceIds: string[], operatorId?: string, weeks?: number): Promise<IReportResponse | null> => {
  try {
    const resp = await axios.post("/json/reports/get", {
      serviceIds,
      operatorId,
      weeks
    });
    return resp.data;
  } catch (error) {
    console.error("Failed to fetch report data:", error);
    return null;
  }
};
